export default {"src":"/_next/static/media/chip.8ca7fb19.svg","height":24,"width":24};